<h2 mat-dialog-title>{{ dialogTitle }}</h2>
<mat-dialog-content class="mat-dialog-content" id="groupName"> {{group.name}} </mat-dialog-content>
<mat-dialog-actions class="mat-dialog-actions" id="dailogActions">
    <button [mat-dialog-close]="true" mat-button id="Yes">Yes</button>
    <button [mat-dialog-close]="false" mat-button id="No">No</button>
</mat-dialog-actions>
